import React, { useEffect, useState } from "react";
import {
  ArrowLeft,
  AlertTriangle,
  CheckCircle2,
  XCircle,
} from "lucide-react";
import axios from "axios";
import { generateApiKey } from "../../../helpers/common.helpers";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../NewDashboard/Layout";

// Dialog Components
const Dialog = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative z-50 bg-white rounded-lg shadow-lg max-w-md w-full mx-4">
        {children}
      </div>
    </div>
  );
};

const DialogTitle = ({ children, onClose }) => {
  return (
    <div className="flex items-center justify-between p-6 border-b">
      <h2 className="text-xl font-semibold">{children}</h2>
      {onClose && (
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <XCircle className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

const DialogContent = ({ children }) => {
  return <div className="p-6">{children}</div>;
};

const DialogActions = ({ children }) => {
  return (
    <div className="flex items-center justify-center gap-3 p-6 border-t">
      {children}
    </div>
  );
};

const Competitioncornerquestion = (props) => {
  const [feddbackopen, setFeddbackopen] = useState(false);
  const [user, setUser] = useState("");
  const [datas, setData] = useState("");
  const [isShown, setIsShown] = useState(false);
  const [ansisShown, setIsShownans] = useState(false);
  const [open, setOpen] = useState(false);
  const [coin, setCoindata] = useState("");
  const [showcoins, setShowcoins] = useState(false);
  const [Jobid, setJobid] = useState("");
  const [Joblink, setJoblink] = useState("");
  const [Jobcategory, setJobcategory] = useState("");
  const [reporttype, setReporttype] = useState("");
  const [reprotdiscrtiption, setreprotdiscrtiption] = useState("");
  const [cod, setCod] = useState({ cod_option: `` });

  const navigate = useNavigate();

  const handleClick = (event) => {
    setIsShown((current) => !current);
  };

  const handleChangesetJobid = (event) => {
    setJobid(event.target.value);
  };

  const handleChangesetJoblink = (event) => {
    setJoblink(event.target.value);
  };

  const handleChangesetJobcategory = (event) => {
    setJobcategory(event.target.value);
  };

  const handleChangediscrtiption = (event) => {
    setreprotdiscrtiption(event.target.value);
  };

  const handleChange = (event) => {
    setReporttype(event.target.value);
  };

  const handleClickOpen = (id, question, question_text) => {
    setJobid(id);
    setJoblink(question);
    setJobcategory(question_text);
    setFeddbackopen(true);
  };

  const handleClose = () => {
    setFeddbackopen(false);
  };

  const LoaderClose = () => {
    setOpen(false);
  };

  const LoaderOpen = () => {
    setOpen(true);
  };

  const handalChnage = (e) => {
    setCod({ ...cod, [e.target.name]: e.target.value });
  };

  const fetchdata = async () => {
    setCod({ cod_option: "" });
    await axios({
      method: "post",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "page-index": generateApiKey(),
      },
      url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/competition-corner/fetchquestion`,
      data: {
        enrol_id: localStorage.getItem("enrol_id"),
        category: localStorage.getItem("category"),
        qid: localStorage.getItem("qid"),
      },
    }).then((res) => {
      setData(res.data);
      LoaderClose();
    });
  };

  const newxquction = async () => {
    setCod({ cod_option: "" });
    setIsShownans(false);
    await axios({
      method: "post",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/competition-corner/nextquestion`,
      data: {
        enrol_id: localStorage.getItem("enrol_id"),
        category: localStorage.getItem("category"),
      },
    }).then((res) => {
      setData(res.data);
    });
  };

  const fetchcoindata = async () => {
    await axios({
      method: "post",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "page-index": generateApiKey(),
      },
      url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/headerdetails/fetchstudentcoins`,
      data: {
        enrol_id: localStorage.getItem("enrol_id"),
      },
    }).then((res) => {
      setCoindata(res.data);
    });
  };

  useEffect(() => {
    var user_id = localStorage.getItem("user_id");
    fetchdata();
    fetchcoindata();
    setUser(user_id);
  }, []);

  const submitForm = async (e) => {
    e.preventDefault();
    LoaderOpen();
    setIsShownans((current) => !current);
    const options = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "page-index": generateApiKey(),
      },
    };
    const sandData = {
      qid: datas.qid,
      correct_answer: parseInt(cod.cod_option),
      difficulty: datas.difficulty,
      answer: datas.answer,
      enrol_id: localStorage.getItem("enrol_id"),
    };
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/competition-corner/submit`,
        JSON.stringify(sandData),
        options
      )
      .then((res) => {
        LoaderClose();
        fetchcoindata();
        setShowcoins(true);
      });
  };

  const submitFormreport = async (e) => {
    LoaderOpen();
    e.preventDefault();

    const options = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    };

    const sandData = {
      enrol_id: parseInt(localStorage.getItem("enrol_id")),
      question_report_type: reporttype,
      question_id: Jobid,
      question_category: parseInt(localStorage.getItem("category")),
      question_report_des: reprotdiscrtiption,
      question_topic: Joblink,
      question_name: Jobcategory,
    };

    await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/ccquestionreportmail/reportquestion`,
        JSON.stringify(sandData),
        options
      )
      .then((result) => {
        if (result.data.status == 200) {
          Swal.fire({
            title: "Success",
            text: "Thank you",
            icon: "success",
            confirmButtonText: "OK",
          });
        }
        setReporttype("");
        setJobid("");
        setJoblink("");
        setJobcategory("");
        setreprotdiscrtiption("");
        LoaderClose();
        handleClose();
      });
  };

  return (
    <>
      <Layout>
        <div className="bg-[#f3f6f9] pb-5 min-h-screen">
          <div className="pt-6 px-4 max-w-7xl mx-auto">
            {/* Back Button */}
            <Link
              to="/Competition-corner"
              className="no-underline text-black flex items-center mb-4 hover:text-gray-700"
            >
              <ArrowLeft className="w-5 h-5 font-bold" />
              <span className="ml-2 font-bold text-base">Back to questions</span>
            </Link>

            {/* Main Card - Matching image design */}
            <div className="bg-white rounded-lg shadow-[rgba(149,157,165,0.2)_0px_8px_24px] w-full lg:w-[90%] py-6">
              {/* Question Header */}
              <div className="flex items-start justify-between mb-6 px-6">
                <div className="flex-1">
                  <h5 className="text-xl font-bold text-gray-900">
                    {datas.question}
                  </h5>
                </div>
                <div className="flex items-center ml-3">
                  <button
                    className="flex items-center text-[#ff3333] text-sm font-semibold cursor-pointer hover:text-[#cc0000] transition-colors"
                    onClick={() =>
                      handleClickOpen(
                        datas.qid,
                        datas.question,
                        datas.question_text
                      )
                    }
                  >
                    <AlertTriangle className="w-4 h-4 mr-1" />
                    Report
                  </button>
                </div>
              </div>

              {/* Question Text and Points Badge - Matching image design */}
              <div className="flex items-start px-6 mb-6 gap-4">
                <div className="flex-1">
                  <p className="text-[17px] text-gray-900 leading-relaxed">
                    Question: {datas.question_text}
                  </p>
                </div>
                <div className="flex-shrink-0 ml-12">
                  <div className="flex items-center gap-1 bg-[#50cd89] text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                    <img
                      src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                      alt="star"
                      className="w-5 h-5 object-contain"
                    />
                    <span className="text-[0.8rem] font-semibold">
                      {(() => {
                        if (datas.difficulty === "Easy") {
                          return "+5";
                        } else if (datas.difficulty === "Medium") {
                          return "+10";
                        } else if (datas.difficulty === "Hard") {
                          return "+15";
                        }
                      })()}
                    </span>
                  </div>
                </div>
              </div>

              <form onSubmit={submitForm}>
                <div className="px-6 py-4">
                  {/* Options - Matching image design with proper spacing */}
                  <div className="space-y-3">
                    {/* Option 1 */}
                    <div className="flex items-start py-2">
                      <div className="flex-1 flex items-start">
                        <input
                          type="radio"
                          id="option1"
                          name="cod_option"
                          value="1"
                          checked={datas.newanswer === 1 || cod.cod_option === "1"}
                          onChange={handalChnage}
                          className="w-[18px] h-[18px] mt-0.5 cursor-pointer accent-[#1976d2]"
                          disabled={datas.attempt === 1}
                        />
                        <label
                          htmlFor="option1"
                          className="ml-3 text-[0.85rem] text-gray-900 cursor-pointer leading-relaxed"
                        >
                          {datas.option1}
                        </label>
                      </div>
                      <div className="w-[200px] flex items-center justify-end pl-4">
                        {(() => {
                          if (datas.answer === 1 && datas.attempt == 1) {
                            return (
                              <CheckCircle2 className="w-6 h-6 text-[#00802b]" />
                            );
                          } else if (
                            datas.answer !== 1 &&
                            datas.attempt == 1 &&
                            datas.newanswer === 1
                          ) {
                            return <XCircle className="w-6 h-6 text-[#ff0000]" />;
                          }
                        })()}
                        {ansisShown && (
                          <>
                            {(() => {
                              if (datas.answer === 1 && datas.attempt == 0) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <CheckCircle2 className="w-6 h-6 text-[#50cd89]" />
                                    <div className="flex items-center gap-1 bg-[#50cd89] text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        {(() => {
                                          if (datas.difficulty === "Easy") {
                                            return "+5";
                                          } else if (datas.difficulty === "Medium") {
                                            return "+10";
                                          } else if (datas.difficulty === "Hard") {
                                            return "+15";
                                          }
                                        })()}
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else if (
                                datas.answer !== 1 &&
                                cod.cod_option === "1" &&
                                datas.attempt == 0
                              ) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <XCircle className="w-6 h-6 text-red-600" />
                                    <div className="flex items-center gap-1 bg-red-600 text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        +0
                                      </span>
                                    </div>
                                  </div>
                                );
                              }
                            })()}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Option 2 */}
                    <div className="flex items-start py-2">
                      <div className="flex-1 flex items-start">
                        <input
                          type="radio"
                          id="option2"
                          name="cod_option"
                          value="2"
                          checked={datas.newanswer === 2 || cod.cod_option === "2"}
                          onChange={handalChnage}
                          className="w-[18px] h-[18px] mt-0.5 cursor-pointer accent-[#1976d2]"
                          disabled={datas.attempt === 1}
                        />
                        <label
                          htmlFor="option2"
                          className="ml-3 text-[0.85rem] text-gray-900 cursor-pointer leading-relaxed"
                        >
                          {datas.option2}
                        </label>
                      </div>
                      <div className="w-[200px] flex items-center justify-end pl-4">
                        {(() => {
                          if (datas.answer === 2 && datas.attempt == 1) {
                            return (
                              <CheckCircle2 className="w-6 h-6 text-[#00802b]" />
                            );
                          } else if (
                            datas.answer !== 2 &&
                            datas.attempt == 1 &&
                            datas.newanswer === 2
                          ) {
                            return <XCircle className="w-6 h-6 text-[#ff0000]" />;
                          }
                        })()}
                        {ansisShown && (
                          <>
                            {(() => {
                              if (datas.answer === 2 && datas.attempt == 0) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <CheckCircle2 className="w-6 h-6 text-[#50cd89]" />
                                    <div className="flex items-center gap-1 bg-[#50cd89] text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        {(() => {
                                          if (datas.difficulty === "Easy") {
                                            return "+5";
                                          } else if (datas.difficulty === "Medium") {
                                            return "+10";
                                          } else if (datas.difficulty === "Hard") {
                                            return "+15";
                                          }
                                        })()}
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else if (
                                datas.answer !== 2 &&
                                cod.cod_option === "2" &&
                                datas.attempt == 0
                              ) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <XCircle className="w-6 h-6 text-red-600" />
                                    <div className="flex items-center gap-1 bg-red-600 text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        +0
                                      </span>
                                    </div>
                                  </div>
                                );
                              }
                            })()}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Option 3 */}
                    <div className="flex items-start py-2">
                      <div className="flex-1 flex items-start">
                        <input
                          type="radio"
                          id="option3"
                          name="cod_option"
                          value="3"
                          checked={datas.newanswer === 3 || cod.cod_option === "3"}
                          onChange={handalChnage}
                          className="w-[18px] h-[18px] mt-0.5 cursor-pointer accent-[#1976d2]"
                          disabled={datas.attempt === 1}
                        />
                        <label
                          htmlFor="option3"
                          className="ml-3 text-[0.85rem] text-gray-900 cursor-pointer leading-relaxed"
                        >
                          {datas.option3}
                        </label>
                      </div>
                      <div className="w-[200px] flex items-center justify-end pl-4">
                        {(() => {
                          if (datas.answer === 3 && datas.attempt == 1) {
                            return (
                              <CheckCircle2 className="w-6 h-6 text-[#00802b]" />
                            );
                          } else if (
                            datas.answer !== 3 &&
                            datas.attempt == 1 &&
                            datas.newanswer === 3
                          ) {
                            return <XCircle className="w-6 h-6 text-[#ff0000]" />;
                          }
                        })()}
                        {ansisShown && (
                          <>
                            {(() => {
                              if (datas.answer === 3 && datas.attempt == 0) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <CheckCircle2 className="w-6 h-6 text-[#50cd89]" />
                                    <div className="flex items-center gap-1 bg-[#50cd89] text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        {(() => {
                                          if (datas.difficulty === "Easy") {
                                            return "+5";
                                          } else if (datas.difficulty === "Medium") {
                                            return "+10";
                                          } else if (datas.difficulty === "Hard") {
                                            return "+15";
                                          }
                                        })()}
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else if (
                                datas.answer !== 3 &&
                                cod.cod_option === "3" &&
                                datas.attempt == 0
                              ) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <XCircle className="w-6 h-6 text-red-600" />
                                    <div className="flex items-center gap-1 bg-red-600 text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        +0
                                      </span>
                                    </div>
                                  </div>
                                );
                              }
                            })()}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Option 4 */}
                    <div className="flex items-start py-2">
                      <div className="flex-1 flex items-start">
                        <input
                          type="radio"
                          id="option4"
                          name="cod_option"
                          value="4"
                          checked={datas.newanswer === 4 || cod.cod_option === "4"}
                          onChange={handalChnage}
                          className="w-[18px] h-[18px] mt-0.5 cursor-pointer accent-[#1976d2]"
                          disabled={datas.attempt === 1}
                        />
                        <label
                          htmlFor="option4"
                          className="ml-3 text-[0.85rem] text-gray-900 cursor-pointer leading-relaxed"
                        >
                          {datas.option4}
                        </label>
                      </div>
                      <div className="w-[200px] flex items-center justify-end pl-4">
                        {(() => {
                          if (datas.answer === 4 && datas.attempt == 1) {
                            return (
                              <CheckCircle2 className="w-6 h-6 text-[#00802b]" />
                            );
                          } else if (
                            datas.answer !== 4 &&
                            datas.attempt == 1 &&
                            datas.newanswer === 4
                          ) {
                            return <XCircle className="w-6 h-6 text-[#ff0000]" />;
                          }
                        })()}
                        {ansisShown && (
                          <>
                            {(() => {
                              if (datas.answer === 4 && datas.attempt == 0) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <CheckCircle2 className="w-6 h-6 text-[#50cd89]" />
                                    <div className="flex items-center gap-1 bg-[#50cd89] text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      
                                      <span className="text-[0.8rem] font-semibold">
                                        {(() => {
                                          if (datas.difficulty === "Easy") {
                                            return "+5";
                                          } else if (datas.difficulty === "Medium") {
                                            return "+10";
                                          } else if (datas.difficulty === "Hard") {
                                            return "+15";
                                          }
                                        })()}
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else if (
                                datas.answer !== 4 &&
                                cod.cod_option === "4" &&
                                datas.attempt == 0
                              ) {
                                return (
                                  <div className="flex items-center gap-3">
                                    <XCircle className="w-6 h-6 text-red-600" />
                                    <div className="flex items-center gap-1 bg-red-600 text-white px-3 py-1 rounded-full min-w-[60px] justify-center">
                                      <img
                                        src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/Student-Dashboard/star.png"
                                        alt="star"
                                        className="w-5 h-5 object-contain"
                                      />
                                      <span className="text-[0.8rem] font-semibold">
                                        +0
                                      </span>
                                    </div>
                                  </div>
                                );
                              }
                            })()}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Hint Section - Matching image design */}
                <div className="px-6 min-h-[70px]">
                  {isShown && (
                    <div className="p-4 shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] rounded-md mb-4">
                      <p className="text-base text-gray-900 mb-0">
                        Hint: {datas.hint_text}
                      </p>
                    </div>
                  )}
                </div>

                {/* Action Buttons - Matching image design */}
                <div className="px-6 pt-5">
                  <div className="grid grid-cols-3 gap-4">
                    {/* Give me a hint button */}
                    <button
                      type="button"
                      onClick={handleClick}
                      className="bg-white shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-md text-black px-4 py-2 text-[15px] hover:bg-gray-50 transition-colors"
                    >
                      Give me a hint
                    </button>

                    {/* Submit button - only show if not attempted */}
                    {datas.attempt !== 1 && (
                      <button
                        type="submit"
                        className="bg-white shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-md text-black px-4 py-2 text-[15px] hover:bg-gray-50 transition-colors"
                      >
                        Submit
                      </button>
                    )}

                    {/* Next Question button */}
                    <button
                      type="button"
                      onClick={newxquction}
                      className="bg-white shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-md text-black px-4 py-2 text-[15px] hover:bg-gray-50 transition-colors"
                    >
                      Next Question
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Report Dialog */}
        <Dialog open={feddbackopen} onClose={handleClose}>
          <DialogTitle onClose={handleClose}>Report Question</DialogTitle>
          <form onSubmit={submitFormreport}>
            <DialogContent>
              <input
                type="hidden"
                id="Jobid"
                value={Jobid}
                onChange={handleChangesetJobid}
              />
              <input
                type="hidden"
                id="Joblink"
                value={Joblink}
                onChange={handleChangesetJoblink}
              />
              <input
                type="hidden"
                id="Jobcategory"
                value={Jobcategory}
                onChange={handleChangesetJobcategory}
              />

              <div className="space-y-4">
                <div className="space-y-2">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="reporttype"
                      value="Wrong question"
                      checked={reporttype === "Wrong question"}
                      onChange={handleChange}
                      className="w-4 h-4"
                    />
                    <span className="text-sm">Wrong question</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="reporttype"
                      value="Didn't understand"
                      checked={reporttype === "Didn't understand"}
                      onChange={handleChange}
                      className="w-4 h-4"
                    />
                    <span className="text-sm">Didn't understand</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="reporttype"
                      value="Typo error"
                      checked={reporttype === "Typo error"}
                      onChange={handleChange}
                      className="w-4 h-4"
                    />
                    <span className="text-sm">Typo error</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="reporttype"
                      value="Other"
                      checked={reporttype === "Other"}
                      onChange={handleChange}
                      className="w-4 h-4"
                    />
                    <span className="text-sm">Other</span>
                  </label>
                </div>

                <textarea
                  id="outlined-multiline-static"
                  placeholder="Explain this report"
                  name="reprotdiscrtiption"
                  value={reprotdiscrtiption}
                  onChange={handleChangediscrtiption}
                  rows="3"
                  className="w-full mt-4 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </DialogContent>
            <DialogActions>
              <button
                type="submit"
                className="bg-[#009ef7] text-white px-6 py-2 rounded-lg hover:bg-[#0086d4] transition-colors"
              >
                Submit
              </button>
              <button
                type="button"
                onClick={handleClose}
                className="bg-[#f5f8fa] text-black px-6 py-2 rounded-lg hover:bg-[#e5e8ea] transition-colors"
              >
                Discard
              </button>
            </DialogActions>
          </form>
        </Dialog>

        {/* Loader Backdrop */}
        {open && (
          <div className="fixed inset-0 z-[1300] flex items-center justify-center bg-black/50">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
          </div>
        )}
      </Layout>
    </>
  );
};

export default Competitioncornerquestion;
